import { render, staticRenderFns } from "./updRmvHprs.vue?vue&type=template&id=5e4bdf91"
import script from "./updRmvHprs.vue?vue&type=script&lang=js"
export * from "./updRmvHprs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports